// extracted by mini-css-extract-plugin
export var tosLink = "_98-0";